/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CronofyCallbackGet$Params {
  code?: string;
  state?: string;
}

export function cronofyCallbackGet(http: HttpClient, rootUrl: string, params?: CronofyCallbackGet$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, cronofyCallbackGet.PATH, 'get');
  if (params) {
    rb.query('code', params.code, {});
    rb.query('state', params.state, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as CalendarStrictHttpResponse<void>;
    })
  );
}

cronofyCallbackGet.PATH = '/Cronofy/Callback';
